import { Icon24DocumentOutline, Icon24PictureOutline } from '@vkontakte/icons';
import baseTheme from '@vkontakte/vkui-tokens/themes/vkBase';

import { FileType } from '../../types/files';

export const getFileIcon = (type: FileType, size = 24) => {
  const Component = {
    [FileType.Image]: Icon24PictureOutline,
    [FileType.File]: Icon24DocumentOutline,
  }[type];

  return <Component width={size} height={size} fill={baseTheme.colorIconSecondary.normal} />;
};
